export interface PortalEditorImageInteractionConfig {
  actionTimeout: number;
  popupHeight: number;
}

export const PortalEditorImageInteractionConfig: PortalEditorImageInteractionConfig = {
  actionTimeout: 10,
  popupHeight: 50,
};
